import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg?react';
import CalculatorIcon from '../../../../../icons/calculator.svg?react';
import optionsTailored from '../../../../../icons/optionsTailored.svg?react'
import choices from '../../../../../icons/choices.svg?react';


export default function PurchasingProcessData() {
    return {
        title: "Our Purchasing Process",
        subtitle: "We offer a wide range of the top rated, most competitively priced insurance companies to provide the highest value coverage. Our team of licensed experts will help you secure the right company and coverage in 3 easy steps.",
        steps: [
            {
                title: "Determine Coverage Amount and Review Quotes",
                icon: CalculatorIcon,
                paragraphs: [
                    "Based on your needs and budget, you can select from $50,000 to $10,000,000 in coverage.",
                    "There are only a handful of questions to get your initial quote from multiple companies. We'll review your top options to help determine the best choice.",
                ]
            },
            {
                title: "Apply and Receive Carrier Approval",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "The application process is simple and can typically be completed right over the phone in less than 10 minutes. Depending on the age and amount of coverage, the approval can be completed in minutes for lower face amounts to up to 15 days if a medical exam is required. You will also be notified via email when your application is approved.",
                ]
            },
            {
                title: "Review Policy and Activate Coverage",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "Once approved by the carrier, you will receive your policy electronically for review. To activate your coverage, you simply need to sign and make your first payment.",
                ]
            },
           
        ],
        stepsfooter:[
            {
                title: "Choice and affordability to meet your budget",
                icon: choices,
                paragraphs: [
                    "As a broker, we are not beholden to only 1 insurance company. We represent a broad range of A rated companies that offer the most competitive prices. That means you get the best options to find the right coverage to meet your needs and budget.",
                ]
            },
            {
                title: "Expert service and easy application process",
                icon: optionsTailored,
                paragraphs: [
                    "We make the application process easy. In some instances, there is no medical exam and only a handful of questions to qualify. In other instances, based on coverage amount and age, a medical exam may be required. Our team of licensed experts are knowledgeable, friendly and will help you find the right policy, customized just for you.",
                ]
            },
            
        ]
    }
}